import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  es: {
    translation: {
      nav: {
        contact: "Contacto"
      },
      hero: {
        title: "Software construido con mentalidad de producto",
        subtitle: "Software con estándares de producto. Limpio, mantenible y construido para durar.",
        cta: "Trabajar con nosotros"
      },
      whatWeDo: {
        title: "Qué hacemos",
        product: {
          title: "Desarrollo de productos",
          description: "Plataformas SaaS full-stack diseñadas para crecimiento y rentabilidad."
        },
        custom: {
          title: "Plataformas a medida",
          description: "Soluciones verticales específicas para industrias"
        },
        integrations: {
          title: "Integraciones y automatización",
          description: "Conectamos sistemas, optimizamos flujos de trabajo, reducimos trabajo manual."
        },
        evolution: {
          title: "Evolución de productos",
          description: "Mantenimiento continuo y desarrollo estratégico de funcionalidades."
        }
      },
      approach: {
        badge: "Enfoque",
        title: "Cómo trabajamos",
        quality: {
          title: "Calidad de producto",
          description: "Cada línea de código pensada para escalar y mantenerse en el tiempo"
        },
        communication: {
          title: "Compromiso long-term",
          description: "Construimos software que mantenemos y evolucionamos. No abandonamos proyectos"
        },
        speed: {
          title: "Atención al detalle",
          description: "Desde el primer deploy hasta el soporte continuo. Software que cuidamos"
        }
      },
      products: {
        title: "Nuestros productos",
        subtitle: "Soluciones verticales específicas para industrias",
        internalOS: {
          name: "Internal OS",
          status: "En vivo",
          description: "Plataforma de operaciones para negocios retail multi-sucursal.",
          details: "Inventario, seguimiento de ventas, gestión de equipos y analítica."
        },
        bovitrack: {
          name: "BoviTrack",
          status: "Beta",
          description: "Plataforma integral de gestión para granjas ganaderas bovinas.",
          details: "Control de rodeos, sanidad animal, reproducción y trazabilidad completa."
        },
        avikorp: {
          name: "Avikorp",
          status: "En desarrollo",
          description: "Sistema completo de administración de granjas avícolas.",
          details: "Gestión de galpones, control de lotes, alimentación y producción de huevos."
        },
        buildos: {
          name: "BuildOS",
          status: "En desarrollo",
          description: "Plataforma de gestión integral para empresas constructoras.",
          details: "Administración de obras, presupuestos, proveedores y control de proyectos."
        }
      },
      philosophy: {
        main: "Construimos productos de software. Selectivamente trabajamos con clientes.",
        sub: "Arquitectura sólida. Código limpio. Comunicación clara."
      },
      contact: {
        title: "Contacto",
        subtitle: "¿Tenés un proyecto interesante?",
        features: {
          fast: {
            title: "Evaluamos cada proyecto",
            description: "No todos los proyectos son un buen fit"
          },
          commitment: {
            title: "Colaboración transparente",
            description: "Hablamos claro desde el día uno"
          },
          custom: {
            title: "Arquitectura personalizada",
            description: "Cada producto construido para sus necesidades específicas"
          }
        }
      },
      footer: {
        copyright: "© 2026 RolfKorp",
        tagline: "Building software products"
      }
    }
  },
  en: {
    translation: {
      nav: {
        contact: "Contact"
      },
      hero: {
        title: "Software built with a product mindset",
        subtitle: "Software with product-grade standards. Clean, maintainable, and built to last.",
        cta: "Work with us"
      },
      whatWeDo: {
        title: "What we do",
        product: {
          title: "Product development",
          description: "Full-stack SaaS platforms designed for growth and profitability."
        },
        custom: {
          title: "Custom platforms",
          description: "Industry-specific vertical solutions"
        },
        integrations: {
          title: "Integrations & automation",
          description: "Connect systems, streamline workflows, reduce manual work."
        },
        evolution: {
          title: "Product evolution",
          description: "Ongoing maintenance and strategic feature development."
        }
      },
      approach: {
        badge: "Approach",
        title: "How we work",
        quality: {
          title: "Product-grade quality",
          description: "Every line of code designed to scale and stand the test of time"
        },
        communication: {
          title: "Long-term commitment",
          description: "We build software we maintain and evolve. We don't abandon projects"
        },
        speed: {
          title: "Attention to detail",
          description: "From first deploy to continuous support. Software we care about"
        }
      },
      products: {
        title: "Our products",
        subtitle: "Industry-specific vertical solutions",
        internalOS: {
          name: "Internal OS",
          status: "Live",
          description: "Operations platform for multi-location retail businesses.",
          details: "Inventory, sales tracking, team management, and analytics."
        },
        bovitrack: {
          name: "BoviTrack",
          status: "Beta",
          description: "Comprehensive management platform for cattle farms.",
          details: "Herd control, animal health, reproduction, and complete traceability."
        },
        avikorp: {
          name: "Avikorp",
          status: "In development",
          description: "Complete administration system for poultry farms.",
          details: "Barn management, batch control, feeding, and egg production."
        },
        buildos: {
          name: "BuildOS",
          status: "In development",
          description: "Comprehensive management platform for construction companies.",
          details: "Project management, budgets, suppliers, and work control."
        }
      },
      philosophy: {
        main: "We build software products. We selectively work with clients.",
        sub: "Solid architecture. Clean code. Clear communication."
      },
      contact: {
        title: "Contact",
        subtitle: "Have an interesting project?",
        features: {
          fast: {
            title: "We evaluate each project",
            description: "Not every project is a good fit"
          },
          commitment: {
            title: "Transparent collaboration",
            description: "We speak clearly from day one"
          },
          custom: {
            title: "Custom architecture",
            description: "Every product built for its specific needs"
          }
        }
      },
      footer: {
        copyright: "© 2026 RolfKorp",
        tagline: "Building software products"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
